module.exports = __webpack_public_path__ + "img/shopping-bag.252e8cc6.svg";